module.exports = __webpack_public_path__ + "static/media/super-netball_logo_rgb_full.6a59aa19.svg";